import { StepInput } from "../StepInput";
import { cn } from "@/lib/utils/common";

type WeightRangeInputProps = {
  minWeight: string | undefined;
  maxWeight: string | undefined;
  onWeightChange: (min: string | undefined, max: string | undefined) => void;
  step?: string;
  className?: string;
};

const MAX_WEIGHT_LENGTH = 8;
const MAX_WEIGHT_VALUE = Math.pow(10, MAX_WEIGHT_LENGTH) - 1;

const legendClassName = "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70";

export function WeightRangeInput({
  minWeight,
  maxWeight,
  onWeightChange,
  step = "1",
  className,
}: WeightRangeInputProps) {
  const stepNum = parseFloat(step);

  const handleWeightChange = ({ value, field }: { value: string | undefined; field: "min" | "max" }) => {
    // If the value is empty, pass undefined
    if (!value) {
      onWeightChange(field === "min" ? undefined : minWeight, field === "max" ? undefined : maxWeight);
      return;
    }

    // Check if the number is within bounds
    const numValue = parseFloat(value);
    if (numValue >= 0 && numValue <= MAX_WEIGHT_VALUE) {
      onWeightChange(field === "min" ? value : minWeight, field === "max" ? value : maxWeight);
    }
  };

  return (
    <fieldset className={cn("w-[220px]", className)}>
      <legend className={legendClassName}>Avg. Weight In (lb)</legend>
      <div className="flex items-center gap-2 pt-2">
        <StepInput
          value={minWeight}
          placeholder="Min"
          onChange={(value) => handleWeightChange({ value, field: "min" })}
          maxLength={MAX_WEIGHT_LENGTH}
          max={MAX_WEIGHT_VALUE}
          step={stepNum}
        />
        <span>-</span>
        <StepInput
          value={maxWeight}
          placeholder="Max"
          onChange={(value) => handleWeightChange({ value, field: "max" })}
          maxLength={MAX_WEIGHT_LENGTH}
          max={MAX_WEIGHT_VALUE}
          step={stepNum}
        />
      </div>
    </fieldset>
  );
}
